import * as actionType from './actionTypes';

const initialState = {};

const refreshSearchReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actionType.SET_REFRESH_SEARCH:
      return action.payload;
    default:
      return state;
  }
};

export default refreshSearchReducer;
